FiltersMdl.service( 'SearchSrv', ['$q', '$http', 'API_URL', 'HuesSrv', 'HuesUpdaterSrv',
	function( $q, $http, API_URL, SubcategoriesFcty, HuesSrv, HuesUpdaterSrv ) {

	var searchResults = [];

	return {

		setScope: function( scope ) {
			this.scope = scope;
		},
		//scope: false,

		//options: [],

		searchHues: function( input ) {
			console.log(this.scope);
			return;

			if( input.length < 2 )
				return;


			var self = this;
			//this.scope.options = [];

			$http.get( API_URL.HUE + '/search-hue/' + input ).then(
					function ( response ) {
						searchResults = response.data;
						if( searchResults.length ) {
							self.scope.options = searchResults.map(function (item) {
								return item['hue'];
							});
						} else
							self.scope.options = [];


						console.log(self.scope.options);


					},
					function (error){
						console.log( error );
					}
			);
		},

		setResults: function(){
			console.log('setResults')
		},

		showResults: function() {
			console.log('showResults')
		}
	}


}]);